/**
 * Dintass · origen de las consultas por WhatsApp
 *
 * Los enlaces wa.me del tema terminan en "Ref: WEB-<LÍNEA>-<SKU>" (snippets/whatsapp-link.liquid).
 * Este script recuerda por dónde llegó el visitante y, al hacer clic en WhatsApp, cambia "WEB" por
 * el canal real y agrega la campaña:  Ref: GADS-FER-1108-150/tornos-septiembre
 *
 *   GADS  Google Ads (gclid, gbraid, wbraid, o utm_source=google con medio pagado)
 *   META  Facebook / Instagram (fbclid o utm_source facebook, instagram, fb, ig, meta)
 *   MAIL  correo (utm_medium=email o utm_source newsletter)
 *   ORG   buscador orgánico (llegó desde Google, Bing, etc. sin parámetros)
 *   WEB   todo lo demás
 *
 * Se guarda la última visita con origen conocido durante 30 días (localStorage). Si el navegador
 * no permite guardar, igual funciona para la visita actual.
 */

const CLAVE = 'dt-origen';
const VIGENCIA_MS = 30 * 24 * 60 * 60 * 1000;
const PAGADO = /^(cpc|ppc|paid|paidsocial|paid_social|cpm|display|ads?)$/i;
const BUSCADORES = /(^|\.)(google|bing|yahoo|duckduckgo|ecosia|yandex)\./i;

function limpiarCampana(valor) {
  return String(valor || '')
    .toLowerCase()
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '')
    .replace(/[^\w.-]+/g, '-')
    .replace(/^-+|-+$/g, '')
    .slice(0, 40);
}

function origenDeLaUrl() {
  const p = new URLSearchParams(window.location.search);
  const fuente = (p.get('utm_source') || '').toLowerCase();
  const medio = (p.get('utm_medium') || '').toLowerCase();
  const campana = limpiarCampana(p.get('utm_campaign'));
  let canal = '';
  if (p.has('gclid') || p.has('gbraid') || p.has('wbraid') || (/google|adwords/.test(fuente) && PAGADO.test(medio))) canal = 'GADS';
  else if (p.has('fbclid') || /^(facebook|fb|instagram|ig|meta)$/.test(fuente)) canal = 'META';
  else if (medio === 'email' || /newsletter|mail/.test(fuente)) canal = 'MAIL';
  else if (fuente || medio || campana) canal = 'WEB';
  if (!canal) {
    try {
      const ref = document.referrer ? new URL(document.referrer).hostname : '';
      if (ref && ref !== window.location.hostname && BUSCADORES.test(ref)) canal = 'ORG';
    } catch (_) {
      /* referrer inválido */
    }
  }
  return canal ? { canal, campana, en: Date.now() } : null;
}

function leer() {
  try {
    const o = JSON.parse(localStorage.getItem(CLAVE) || 'null');
    return o && Date.now() - o.en < VIGENCIA_MS ? o : null;
  } catch (_) {
    return null;
  }
}

function guardar(o) {
  try {
    localStorage.setItem(CLAVE, JSON.stringify(o));
  } catch (_) {
    /* almacenamiento bloqueado: se usa solo en esta visita */
  }
}

const deEstaVisita = origenDeLaUrl();
if (deEstaVisita) guardar(deEstaVisita);
const origen = () => deEstaVisita || leer();

// ---- Contexto de la página para los botones genéricos (05-10-2026) ----
// El enlace "Cotiza por WhatsApp" de la barra superior y el botón flotante en colecciones mandaban solo
// "necesito asesoría. Ref: WEB-GEN", aunque el cliente estuviera mirando una ficha o una colección, y Lia
// no sabía de dónde venía. layout/theme.liquid deja la página en <script id="dt-pagina"> y acá se arma:
//   ficha      → "tengo una consulta sobre: <producto> (SKU X). <url> Ref: WEB-<LÍNEA>-<SKU>"
//   colección  → "necesito asesoría sobre <colección>. <url> Ref: WEB-<LÍNEA>-COL-<HANDLE>"
//   otra página→ "necesito asesoría (estoy viendo: <título>). Ref: WEB-GEN"
function pagina() {
  try {
    return JSON.parse(document.getElementById('dt-pagina')?.textContent || 'null');
  } catch (_) {
    return null;
  }
}
const lineaDe = (pilar) => (pilar === 'maquinas' || pilar === 'rectificado' ? 'MAQ' : pilar ? 'FER' : '');
const comoCodigo = (s) =>
  String(s || '')
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '')
    .toUpperCase()
    .replace(/[^A-Z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');

export function conContextoDePagina(texto, p) {
  const m = String(texto || '').match(/Ref: WEB-(?:(MAQ|FER)-)?GEN\b/);
  if (!m || !p) return texto;
  const linea = m[1] || lineaDe(p.pilar);
  const ref = linea ? `${linea}-` : '';
  if (p.tipo === 'product' && p.producto && p.producto.titulo) {
    const sku = p.producto.sku || '';
    return `Hola Dintass, tengo una consulta sobre: ${p.producto.titulo}${sku ? ` (SKU ${sku})` : ''}. ${p.producto.url || ''} Ref: WEB-${ref}${comoCodigo(sku) || 'PROD'}`.replace(/\s+/g, ' ');
  }
  if (p.tipo === 'collection' && p.coleccion && p.coleccion.titulo) {
    return `Hola Dintass, necesito asesoría sobre ${p.coleccion.titulo}. ${p.coleccion.url || ''} Ref: WEB-${ref}COL-${comoCodigo(p.coleccion.handle)}`.replace(/\s+/g, ' ');
  }
  if (p.titulo && p.tipo !== 'index' && p.tipo !== '404') {
    const titulo = String(p.titulo).replace(/\s*[|–-]\s*Dintass( Motori)?\s*$/i, '').trim();
    if (titulo) return texto.replace(/necesito asesoría\./, `necesito asesoría (estoy viendo: ${titulo}).`);
  }
  return texto;
}

// Justo antes de abrir WhatsApp: agrega el contexto de la página a los botones genéricos y cambia "WEB" por el canal real.
document.addEventListener(
  'click',
  (event) => {
    const a = event.target instanceof Element ? event.target.closest('a[href*="wa.me/"]') : null;
    if (!a) return;
    try {
      const url = new URL(a.href);
      const texto = url.searchParams.get('text');
      if (!texto || !/Ref: WEB-/.test(texto)) return;
      let nuevo = conContextoDePagina(texto, pagina());
      const o = origen();
      if (o) nuevo = nuevo.replace(/Ref: WEB-(\S+)/, (_, resto) => `Ref: ${o.canal}-${resto}${o.campana ? `/${o.campana}` : ''}`);
      if (nuevo !== texto) {
        url.searchParams.set('text', nuevo);
        a.href = url.toString();
      }
    } catch (_) {
      /* enlace raro: se deja tal cual */
    }
  },
  true,
);
